import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Reveal } from "@/components/site/Primitives";
import { LEADERS } from "@/lib/leadership";

const LeaderCard = ({ p, i, onOpen }) => (
  <Reveal delay={(i % 4) * 0.05}>
    <button onClick={() => onOpen(p)} data-testid={`leader-card-${p.slug}`} className="group block w-full text-left">
      <div className="relative aspect-square overflow-hidden bg-[#0B1D4F]">
        <img src={`/img/team/${p.slug}.jpg`} alt={`${p.name}, ${p.title}`} loading="lazy" className="h-full w-full object-cover grayscale-[35%] transition-[filter,transform] duration-700 group-hover:scale-105 group-hover:grayscale-0" />
        <span className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 bg-[#C8102E] transition-transform duration-500 group-hover:scale-x-100" />
      </div>
      <p className="font-display mt-4 text-2xl font-bold uppercase leading-none">{p.name}</p>
      <p className="mt-1.5 text-sm text-[#D4A24C]">{p.title}</p>
      <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-slate-200 group-hover:text-white">Read bio <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></span>
    </button>
  </Reveal>
);

export const LeadershipGrid = () => {
  const [active, setActive] = useState(null);
  return (
    <>
      <div data-testid="leadership-grid" className="grid grid-cols-2 gap-x-5 gap-y-10 md:grid-cols-3 lg:grid-cols-4">
        {LEADERS.map((p, i) => <LeaderCard key={p.slug} p={p} i={i} onOpen={setActive} />)}
      </div>
      <Dialog open={!!active} onOpenChange={(o) => { if (!o) setActive(null); }}>
        <DialogContent data-testid="leader-dialog" data-lenis-prevent className="max-h-[88vh] overflow-y-auto rounded-none border-white/15 bg-[#0B1D4F] sm:max-w-3xl">
          {active && (
            <div className="grid gap-6 md:grid-cols-[200px_1fr]">
              <img src={`/img/team/${active.slug}.jpg`} alt={active.name} className="aspect-square w-40 object-cover md:w-full" />
              <div>
                <DialogHeader className="text-left">
                  <DialogTitle data-testid="leader-dialog-name" className="font-display text-4xl font-bold uppercase leading-none">{active.name}</DialogTitle>
                  <DialogDescription className="text-[#D4A24C]">{active.title}</DialogDescription>
                </DialogHeader>
                <div className="mt-5 space-y-4 text-sm leading-relaxed text-slate-200">
                  {active.bio.map((b) => <p key={b.slice(0, 40)}>{b}</p>)}
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
